import { once } from 'fxjs/es';
import { CreatorCriteoF } from './module/CreatorCriteoF.js';

export const viewItem = once(({ id }) => {
  if (!window.criteo_q) return;
  window.criteo_q.push(...CreatorCriteoF.eventSet({ event: 'viewItem', item: id }));
});
